// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ChevronUpSmallIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ChevronUpSmallIcon" ref={forwardedRef} {...props}>
      <path d="M14.243 11.243 10 7l-4.243 4.243 1.061 1.06L10 9.121l3.182 3.182z" />
    </SvgIcon>
  );
});

/**
 * Indicates the ability to collapse a dropdown
 * @public
 */
export const ChevronUpSmallIcon = /* @__PURE__ */ Object.assign(
  ChevronUpSmallIconComponent,
  { displayName: 'ChevronUpSmallIcon' },
);
